import { FaRegCopyright } from "react-icons/fa";
import { FaGripLinesVertical } from "react-icons/fa6";
import { MdKeyboardDoubleArrowLeft } from "react-icons/md";
import { RiArrowRightDoubleFill } from "react-icons/ri";

const Footer = ({ sidebarCollapsed, setSidebarCollapsed }) => {
  return (
    <footer className="fixed bottom-0 left-0 w-full border-t border-gray-200 bg-white shadow-sm py-2 z-50">
      <div className="relative w-full h-full flex items-center justify-start px-4">
        {/* Left-Aligned Button */}
        <button
          onClick={() => {
            localStorage.setItem("sidebar-expanded", !sidebarCollapsed);
            setSidebarCollapsed(!sidebarCollapsed);
          }}
          className="text-primary rounded-md w-10 h-10 flex items-center justify-center"
        >
          {sidebarCollapsed ? (
            <RiArrowRightDoubleFill className="text-xl" />
          ) : (
            <MdKeyboardDoubleArrowLeft className="text-xl" />
          )}
        </button>
        {/* Perfectly Centered Text */}
        <div className="absolute left-1/2 transform -translate-x-1/2 text-sm tracking-wide text-gray-700 flex items-center gap-4">
          <span className="font-semibold capitalize">
            Design & Develop by{" "}
            <span className="text-primary">MSM SOLUTION</span>
          </span>
          <FaGripLinesVertical className="text-[#405189] text-xl" />
          <span className="flex items-center gap-1">
            <FaRegCopyright />
            <span className="capitalize font-semibold">2025 AluEx</span>
          </span>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
